import { useEffect, useRef } from "react";
import * as PIXI from "pixi.js";

import zombieKid from "../../assets/imdv_logo_zombie_kid.png";
import text from "../../assets/imdv_logo_text.png";

import imdvlogo from "./imdvlogo.css";

export default function IMDVLogo() {
    const containerRef = useRef(null);

    useEffect(() => {
        let app;

        async function initPixi() {
            app = new PIXI.Application();

            await app.init({
                width: 1600,
                height: 500,
                backgroundAlpha: 0,
                antialias: true
            });

            if (!containerRef.current) return;

            containerRef.current.appendChild(app.canvas);

            const zombieTexture = await PIXI.Assets.load(zombieKid);
            const textTexture = await PIXI.Assets.load(text);

            const zombieSprite = new PIXI.Sprite(zombieTexture);
            const textSprite = new PIXI.Sprite(textTexture);

            // COLORS //
            zombieSprite.tint = 0x450f00;
            textSprite.tint = 0x692704;

            zombieSprite.alpha = 0.95;
            textSprite.alpha = 0.95;

            // CENTER ANCHORS //
            zombieSprite.anchor.set(0.5);
            textSprite.anchor.set(0.5);

            // SCALE ENTIRE LOGO //
            const scale = 0.45;

            zombieSprite.scale.set(scale);
            textSprite.scale.set(scale);

            // CENTER OF CANVAS //
            const centerX = app.screen.width / 2;
            const centerY = app.screen.height / 2;

            zombieSprite.position.set(centerX, centerY);
            textSprite.position.set(centerX, centerY);

            // zombieSprite.blendMode = "multiply";
            // textSprite.blendMode = "multiply";

            app.stage.addChild(zombieSprite);
            app.stage.addChild(textSprite);
        }

        initPixi();

        return () => {
            if (app) {
                app.destroy(true);
            }
        };
    }, []);

    return (
        <div className="imdv-logo" ref={containerRef}/>
    );
}